'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertCircle } from '@subframe/core';
import { Alert, Button, LazyLoader, PageHeader_Main } from '@/shared/components/ui';
import { useConfiguracaoDaSimulacaoDoAdmin } from '../hooks/useConfiguracaoDaSimulacaoDoAdmin';
import { useContextoDaSimulacaoDoAdmin } from '../hooks/useContextoDaSimulacaoDoAdmin';
import { useConversaNaTela } from '../hooks/useConversaNaTela';
import type { SimulacaoDoAdminProps, TelaDaSimulacaoDoAdminProps } from '../types';
import { AvisosDaConversa } from './AvisosDaConversa';
import { CamposDeInicio } from './CamposDeInicio';
import { FaixaDaExecucao } from './FaixaDaExecucao';
import { ModoDaSimulacaoDoAdmin } from './ModoDaSimulacaoDoAdmin';
import { PassosDaSimulacao } from './PassosDaSimulacao';
import { SimulacaoActions } from './SimulacaoActions';
import { SimulacaoAvancoDoRelogio } from './SimulacaoAvancoDoRelogio';
import { SimulacaoChatPreview } from './SimulacaoChatPreview';
const TelaDaSimulacaoDoAdmin = t0 => {
  const $ = _c(70);
  const {
    trocarEscritorio,
    renderizarSeletorDeEscritorio
  } = t0;
  const configuracao = useConfiguracaoDaSimulacaoDoAdmin();
  const {
    conversa,
    chat,
    baixar
  } = useConversaNaTela(configuracao.agentName);
  const {
    escritorioId,
    iniciando
  } = configuracao;
  const t1 = !configuracao.podeIniciar;
  const t2 = conversa.hasMessages && !conversa.paginacao.exportacao.carregando;
  let t3;
  if ($[0] !== baixar || $[1] !== configuracao.iniciar || $[2] !== conversa.hasVisibleMessages || $[3] !== conversa.limpar || $[4] !== conversa.started || $[5] !== t1 || $[6] !== t2) {
    t3 = <PageHeader_Main title="Testar agente" subtitle={"Voc\xEA participa como cliente; a Lexi responde como agente."} actions={<SimulacaoActions started={conversa.started} restartDisabled={t1} hasMessages={t2} hasVisibleMessages={conversa.hasVisibleMessages} onClear={conversa.limpar} onRestart={configuracao.iniciar} onDownload={baixar} />} className="max-w-[1160px] border-0 pb-0" />;
    $[0] = baixar;
    $[1] = configuracao.iniciar;
    $[2] = conversa.hasVisibleMessages;
    $[3] = conversa.limpar;
    $[4] = conversa.started;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== configuracao.erroDoEncerramento || $[9] !== conversa.carregarMais || $[10] !== conversa.exportError || $[11] !== conversa.paginacao.carregando || $[12] !== conversa.paginacao.erro || $[13] !== conversa.paginacao.exportacao || $[14] !== conversa.paginacao.temMais) {
    t4 = <AvisosDaConversa exportacao={conversa.paginacao.exportacao} temMaisEventos={conversa.paginacao.temMais} carregandoEventos={conversa.paginacao.carregando} erroDosEventos={conversa.paginacao.erro} onCarregarMais={conversa.carregarMais} erroDaExportacao={conversa.exportError} erroDoEncerramento={configuracao.erroDoEncerramento} />;
    $[8] = configuracao.erroDoEncerramento;
    $[9] = conversa.carregarMais;
    $[10] = conversa.exportError;
    $[11] = conversa.paginacao.carregando;
    $[12] = conversa.paginacao.erro;
    $[13] = conversa.paginacao.exportacao;
    $[14] = conversa.paginacao.temMais;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const t5 = !configuracao.podeIniciar;
  let t6;
  if ($[16] !== configuracao.configuracaoAlterada || $[17] !== configuracao.fluxoSemAgente || $[18] !== configuracao.identificacao || $[19] !== configuracao.iniciar || $[20] !== t5) {
    t6 = <FaixaDaExecucao identificacao={configuracao.identificacao} fluxoSemAgente={configuracao.fluxoSemAgente} configuracaoAlterada={configuracao.configuracaoAlterada} reiniciarDesabilitado={t5} onReiniciar={configuracao.iniciar} />;
    $[16] = configuracao.configuracaoAlterada;
    $[17] = configuracao.fluxoSemAgente;
    $[18] = configuracao.identificacao;
    $[19] = configuracao.iniciar;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  let t8;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h2 id="configuracao-simulacao-admin" className="text-heading-3 font-heading-3 text-default-font">Configure o teste</h2>;
    t8 = <p className="text-body text-subtext-color mt-1">Escolha o escritório e a configuração do agente que você quer testar.</p>;
    $[22] = t7;
    $[23] = t8;
  } else {
    t7 = $[22];
    t8 = $[23];
  }
  const t9 = escritorioId ?? "";
  let t10;
  if ($[24] !== iniciando || $[25] !== renderizarSeletorDeEscritorio || $[26] !== t9 || $[27] !== trocarEscritorio) {
    t10 = renderizarSeletorDeEscritorio({
      value: t9,
      onChange: trocarEscritorio,
      disabled: iniciando
    });
    $[24] = iniciando;
    $[25] = renderizarSeletorDeEscritorio;
    $[26] = t9;
    $[27] = trocarEscritorio;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10) {
    t11 = <div className="mt-6">{t10}</div>;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== configuracao.alterarDado || $[32] !== configuracao.carregandoConfiguracao || $[33] !== configuracao.erroDaConfiguracao || $[34] !== configuracao.errors || $[35] !== configuracao.escolherModo || $[36] !== configuracao.modo || $[37] !== configuracao.opcoesDeModo || $[38] !== configuracao.recarregarConfiguracao || $[39] !== configuracao.situacaoDosCampos || $[40] !== configuracao.textoSemCampos || $[41] !== configuracao.valores || $[42] !== configuracao.variables || $[43] !== escritorioId || $[44] !== iniciando) {
    t12 = !escritorioId ? <p className="text-body text-subtext-color mt-6">Escolha o escritório para carregar a configuração do agente.</p> : <>{configuracao.erroDaConfiguracao && <Alert role="alert" className="mt-6" variant="error" tone="filled" icon={<FeatherAlertCircle />} title={"N\xE3o foi poss\xEDvel carregar a configura\xE7\xE3o do agente."} description={configuracao.erroDaConfiguracao.mensagem} actions={<Button variant="neutral-secondary" size="small" disabled={configuracao.carregandoConfiguracao} onClick={configuracao.recarregarConfiguracao}>Tentar novamente</Button>} />}<ModoDaSimulacaoDoAdmin opcoes={configuracao.opcoesDeModo} modo={configuracao.modo} disabled={iniciando || configuracao.carregandoConfiguracao} onChange={configuracao.escolherModo} /><CamposDeInicio situacao={configuracao.situacaoDosCampos} descricao={"Os campos mudam conforme a configura\xE7\xE3o escolhida."} textoSemAgente={configuracao.textoSemCampos} variables={configuracao.variables} valores={configuracao.valores} errors={configuracao.errors} onChange={configuracao.alterarDado} onRecarregar={configuracao.recarregarConfiguracao} /></>;
    $[31] = configuracao.alterarDado;
    $[32] = configuracao.carregandoConfiguracao;
    $[33] = configuracao.erroDaConfiguracao;
    $[34] = configuracao.errors;
    $[35] = configuracao.escolherModo;
    $[36] = configuracao.modo;
    $[37] = configuracao.opcoesDeModo;
    $[38] = configuracao.recarregarConfiguracao;
    $[39] = configuracao.situacaoDosCampos;
    $[40] = configuracao.textoSemCampos;
    $[41] = configuracao.valores;
    $[42] = configuracao.variables;
    $[43] = escritorioId;
    $[44] = iniciando;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  const t13 = !configuracao.podeIniciar;
  const t14 = conversa.started ? "Reiniciar simula\xE7\xE3o" : "Iniciar simula\xE7\xE3o";
  let t15;
  if ($[46] !== configuracao.iniciar || $[47] !== t13 || $[48] !== t14) {
    t15 = <Button className="mt-6 w-full justify-center" disabled={t13} onClick={configuracao.iniciar}>{t14}</Button>;
    $[46] = configuracao.iniciar;
    $[47] = t13;
    $[48] = t14;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  let t16;
  if ($[50] !== configuracao.erroDoInicio) {
    t16 = configuracao.erroDoInicio && <div role="alert" className="text-error-600 mt-3 flex flex-wrap items-center gap-2"><FeatherAlertCircle /><span className="text-caption">{configuracao.erroDoInicio.mensagem}</span></div>;
    $[50] = configuracao.erroDoInicio;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  let t18;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <SimulacaoAvancoDoRelogio />;
    t18 = <p className="text-caption text-subtext-color mt-3">Nenhuma mensagem é enviada pelo WhatsApp.</p>;
    $[52] = t17;
    $[53] = t18;
  } else {
    t17 = $[52];
    t18 = $[53];
  }
  let t19;
  if ($[54] !== t11 || $[55] !== t12 || $[56] !== t15 || $[57] !== t16) {
    t19 = <section aria-labelledby="configuracao-simulacao-admin" className="bg-default-background flex min-w-0 flex-col rounded-[16px] border border-solid border-neutral-200 p-6">{t7}{t8}{t11}{t12}{t15}{t16}{t17}{t18}</section>;
    $[54] = t11;
    $[55] = t12;
    $[56] = t15;
    $[57] = t16;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  if ($[59] !== chat) {
    t20 = <SimulacaoChatPreview {...chat} />;
    $[59] = chat;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  let t21;
  if ($[61] !== t19 || $[62] !== t20) {
    t21 = <div className="mt-6 grid w-full max-w-[1160px] grid-cols-1 items-start gap-6 xl:grid-cols-[minmax(340px,1fr)_390px]">{t19}{t20}</div>;
    $[61] = t19;
    $[62] = t20;
    $[63] = t21;
  } else {
    t21 = $[63];
  }
  let t22;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <PassosDaSimulacao />;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  let t23;
  if ($[65] !== t21 || $[66] !== t3 || $[67] !== t4 || $[68] !== t6) {
    t23 = <div className="flex h-full w-full flex-col overflow-auto p-6 md:p-9">{t3}{t4}{t6}{t21}{t22}</div>;
    $[65] = t21;
    $[66] = t3;
    $[67] = t4;
    $[68] = t6;
    $[69] = t23;
  } else {
    t23 = $[69];
  }
  return t23;
};

/**
 * A simulação completa no admin (TELA-LEXI-SIM-001 com o contexto de desenvolvimento): a mesma
 * conversa, relógio, assinatura e exportação do cliente, com o escritório e o modo escolhidos
 * aqui e os logs de execução. A especificação não tem mock desta tela; a composição reaproveita
 * a do cliente.
 */
export const SimulacaoDoAdmin = t0 => {
  const $ = _c(8);
  const {
    flowId,
    escritorioIdInicial,
    renderizarSeletorDeEscritorio
  } = t0;
  let t1;
  if ($[0] !== escritorioIdInicial || $[1] !== flowId) {
    t1 = {
      flowId,
      escritorioIdInicial
    };
    $[0] = escritorioIdInicial;
    $[1] = flowId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    pronto,
    escritorioId,
    trocarEscritorio
  } = useContextoDaSimulacaoDoAdmin(t1);
  if (!pronto) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <LazyLoader />;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  const t2 = escritorioId ?? "sem-escritorio";
  let t3;
  if ($[4] !== renderizarSeletorDeEscritorio || $[5] !== t2 || $[6] !== trocarEscritorio) {
    t3 = <TelaDaSimulacaoDoAdmin key={t2} trocarEscritorio={trocarEscritorio} renderizarSeletorDeEscritorio={renderizarSeletorDeEscritorio} />;
    $[4] = renderizarSeletorDeEscritorio;
    $[5] = t2;
    $[6] = trocarEscritorio;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};